module.exports = require('./_core');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_path.js
// module id = 870
// module chunks = 10